import { useState } from "react";
import { Header, Footer, Button, ReservationConfirmed } from "../components";
import "../styles/reservation.css";

const Reservation = () => {
  const [formState, setFormState] = useState({
    date: null,
    time: null,
    numOfGuest: null,
    occasion: null,
  });

  const [reservationSuccessful, setReservationSuccessful] = useState(false);

  const handleChange = (event) => {
    setFormState({
      ...formState,
      [event.target.name]: event.target.value,
    });
  };

  const handleClick = () => {
    const { date, time, numOfGuest, occasion } = formState;
    if (date && time && numOfGuest && occasion) {
      setReservationSuccessful(true);
    }
  }

  return (
    <>
      <Header />
      <section className="reservation">
        {!reservationSuccessful ? (
          <>
            <header>Table Reservation</header>
            <div className="reservation-container">
              <form>
                <div>
                  <label htmlFor="date">Date</label>
                  <input
                    type="date"
                    name="date"
                    id="date"
                    required
                    onChange={handleChange}
                  />
                </div>

                <div>
                  <label htmlFor="time">Time</label>
                  <input
                    type="time"
                    name="time"
                    id="time"
                    required
                    onChange={handleChange}
                  />
                </div>

                <div>
                  <label htmlFor="numOfGuest">Number of Guest</label>
                  <input
                    type="number"
                    name="numOfGuest"
                    id="numOfGuest"
                    required
                    onChange={handleChange}
                  />
                </div>

                <div>
                  <label htmlFor="occasion">Occasion</label>
                  <select
                    name="occasion"
                    id="occasion"
                    defaultValue="birthday"
                    required
                    onChange={handleChange}
                  >
                    <option value="birthday">Birthday</option>
                    <option value="anniversary">Anniversary</option>
                  </select>
                </div>

                <Button type="submit" onClick={handleClick}>Reserve</Button>
              </form>
            </div>
          </>
        ) : (
          <ReservationConfirmed />
        )}
      </section>
      <Footer />
    </>
  );
};

export default Reservation;
